import { render, staticRenderFns } from "./contactDetailModal.vue?vue&type=template&id=04f8385a&scoped=true&"
import script from "./contactDetailModal.vue?vue&type=script&lang=js&"
export * from "./contactDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f8385a",
  null
  
)

export default component.exports